import React from "react";
import { Button, ButtonVariant } from "@merge-api/merge-javascript-shared";

type CancelAndNextFooterProps = {
  onCancel: () => void;
  onNext: () => void;
  className?: string;
  isNextDisabled?: boolean;
  isLoading?: boolean;
  buttonText?: string;
};

const CancelAndNextFooter = ({
  onCancel,
  onNext,
  className,
  buttonText,
  isNextDisabled = false,
  isLoading = false,
}: CancelAndNextFooterProps) => {
  return (
    <div className={`${className} flex items-center justify-end gap-6 !hover:cursor-pointer`}>
      <Button
        onClick={() => {
          onCancel();
        }}
        variant={ButtonVariant.TextBlack}
      >
        Cancel
      </Button>
      <div>
        <Button
          loading={isLoading}
          disabled={isNextDisabled}
          onClick={() => {
            onNext();
          }}
        >
          {buttonText || "Next"}
        </Button>
      </div>
    </div>
  );
};

export default CancelAndNextFooter;
